import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AccountUserService } from '../service/account.service';
import { Observable } from 'rxjs';
import { ReadActivitiesByIdsPayload } from '../modules/shared/models/activity-list-payload.model';


@Injectable()
export class NotificationService {

    appUrl = "";
    localAppUrl = "";
    messApi = '';
    appUrlStream = "";
    activity = "";
    activityNote = "";
    user: any;
    notificationUrl = "";

    private headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'organizationId': 35 + '',
        'userId': 45 + '',
        'loginAuditId': 2761 + '',
        'authToken': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJhNzRkMWU1NS0yZjgwLTQxMDEtOWM1ZC0xMjc0OTBmNWIyZTkiLCJleHAiOjE2MTYxNjMxNDF9.9PzTRfSOgBUsa_t-My0pzjIk_lZdZFHGym8V39jcws4' + '',
        'sessionId': 'qwerty',
        'sourceType': 'Web',
        'userSource': '1.1.1'
    });

    constructor(private http: HttpClient, private accountUserService: AccountUserService) {
        this.accountUserService.user.subscribe(x => this.user = x);
        this.appUrl = environment.apiStreamUrl + "Stream/";
        this.appUrlStream = environment.apiStreamUrl + "Stream";
        this.messApi = environment.apiStreamUrl;
        this.localAppUrl = environment.localApiUrl;
        this.notificationUrl = environment.notificationUrl;
        this.activity = environment.activity + "/LionO360/2.0/API/RepeatType";
        this.activityNote = environment.activity + "/LionO360/2.0/API/Note/Comment";
    }


    getNotifications() {
        let url = this.notificationUrl;
        return this.http.get<any>(url, {
            headers : this.headers,
            responseType: 'text' as 'json'
        })
        .toPromise()
        .then(res => res);
    }

    markReadNotification(id) {
        let url = this.notificationUrl + "/" + id;
        return this.http.put<any>(url, null)
            .toPromise()
            .then(res => res);
    }

    markReadNotificationAll(obj) {
        let url = this.notificationUrl + "/MarkAsRead"
        return this.http.put<any>(url, obj,
            )
            .toPromise()
            .then(res => res);
    }

    readUnreadNotifcation(data: any){
        return this.http.post<any>(environment.activity + `/LionO360/2.0/API/V2/Activity/MarkReadUnreadStatusFromNotification`, data);
    }

    readActivitiesByIds(requestPayload: ReadActivitiesByIdsPayload[]): Observable<any> {
        return this.http.post(environment.activity + "/LionO360/2.0/API/V2/Activity/MarkReadUnreadStatusAssociatedModule", requestPayload);
    }

}
